import { Route as AuthenticatedRoute } from "../routes/_authenticated"
import type { AuthedUser } from "./me.query"

export const useMe = (): AuthedUser => {
  const { user }: { user: AuthedUser } = AuthenticatedRoute.useRouteContext()
  return user
}
